<template>
    <div class="modal fade game-point-note-modal" id="qrPreviewModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content" style="border: none;">
                <div class="modal-body">
                    <section class="sub-header-wrapper">
                        <div class="qrPreview-image">
                            <img data-bs-dismiss="modal" @click="closeOffer" class="gp-closeButton"
                                src="@/assets/images/closeButton.svg" alt="closebutton">
                            <a href="javascript:void(0)">
                                <img :src="qrCode"
                                    class="offer-img" alt="qrcodeimage">
                            </a>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'qrcodemodal',
    props: ['qrCode']
}
</script>

<style>

</style>